<template>
    <div>
        <Hero />
        <HomePageContact v-if="webshopSettings().hasDispatchTypes" id="contact" />
        <HomePageContentBlocks id="about" />
        <HomePageReview v-if="reviews().hasReviews" id="review" :bg-fill="webshopSettings()?.filteredContentBlocks?.length % 2 === 0" />
        <HomePageBusinessInfo id="contact" :bg-fill="(webshopSettings()?.filteredContentBlocks?.length + (reviews().hasReviews ? 1 : 0)) % 2 === 0" />
    </div>
</template>

<script setup async lang="ts">
    import Hero from '~/components/Hero/Hero.vue'
    import HomePageBusinessInfo from '~/components/HomePage/HomePageBusinessInfo.vue'
    import HomePageContact from '~/components/HomePage/HomePageContact.vue'
    import HomePageContentBlocks from '~/components/HomePage/HomePageContentBlocks.vue'
    import HomePageReview from '~/components/HomePage/HomePageReview.vue'
    import { reviews } from '~/store/reviews'
    import { webshopSettings } from '~/store/webshopSettings'
    useHead({
        title: 'Home'
    })
    await reviews().fetchReviewStats()
    await reviews().fetchCustomerReviews(3, 1)
</script>
